// Central site configuration — easy to edit
export const SITE = {
  brandName: "Glotaris",
  professionalName: "Jorge Mario Arango Guzmán",
  matricula: "JUCEA-AM Nº 45",
  whatsapp: "5592991637001", // E.164 sem '+' para wa.me
  whatsappDisplay: "+55 92 99163-7001",
  email: "gringo_arango@hotmail.com",
  city: "Manaus, Amazonas — Brasil",
  address: "R. 27, 1090 — Parque Dez de Novembro, Manaus — AM, CEP 69055-450",
  mapsShortUrl: "https://maps.app.goo.gl/Z75WRoif2Y8DkQVk6?g_st=aw",
  mapsEmbedUrl: "https://www.google.com/maps?q=R.+27,+1090+-+Parque+Dez+de+Novembro,+Manaus+-+AM,+69055-450&output=embed",
  juceaVerifyUrl: "https://www.jucea.am.gov.br/tradutores/",
  yearsExperience: 15,
  priceFrom: "R$ 120",
  media: {
    logo: "https://customer-assets.emergentagent.com/job_tradutor-juramentado/artifacts/1u1iuii4_Bazaart_26E184E4-5800-48B1-A004-47639020C7ED.jpeg",
    logoMark: "https://customer-assets.emergentagent.com/job_tradutor-juramentado/artifacts/bww6swon_Bazaart_BA2251DD-25CE-48F5-90C0-4F6A0F77C922.jpeg",
    portrait: "https://customer-assets.emergentagent.com/job_tradutor-juramentado/artifacts/dk8m7385_94bdc6c4-933c-4494-a8e4-d60f31ef5044.jpeg",
    paperTexture: "https://static.prod-images.emergentagent.com/jobs/663d943d-1646-4917-ad1f-c4ccf4ddf96e/images/4c45b81841d4da3429d1e102f8730614d19914bac6fc7952095ad8973024e3cb.png",
    seal: "https://customer-assets.emergentagent.com/job_tradutor-juramentado/artifacts/fpfau6ce_e200ad15-7bfc-49d1-b0ef-c3bebc1b1205.jpeg",
    pen: "https://images.unsplash.com/photo-1455390582262-044cdead277a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxsZWdhbCUyMGRvY3VtZW50JTIwc2lnbmF0dXJlJTIwcGVufGVufDB8fHx8MTc3OTEzOTQwMnww&ixlib=rb-4.1.0&q=85",
    officeAbstract: "https://static.prod-images.emergentagent.com/jobs/663d943d-1646-4917-ad1f-c4ccf4ddf96e/images/f9f1976360f737375832d5cf71d123ccb4953a7c2eb55a2d4a13d8f4b75638dc.png",
  },
};

export const waUrl = (text) => {
  const base = `https://wa.me/${SITE.whatsapp}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
